import { TicketSalesTour } from '../types/ticketSales';

export const ticketSalesMockData: TicketSalesTour = {
  id: 'tour-004',
  name: 'Zakir Khan : Papa Yaar',
  headliner: 'Zakir Khan',
  coHeadliners: '-',
  company: 'AEG Presents UK',
  multiLegTour: '-',
  buyer: 'OML',
  operator: 'Jacob L.',
  venues: [
    {
      id: 'venue-o2',
      name: 'O2 Arena',
      showCount: 2,
      firstEventDate: '2025-05-10',
      shows: [
        {
          id: 'show-o2-1',
          showNumber: 1,
          eventDate: '2025-05-10',
          allocations: [
            {
              id: 'alloc-o2-1-1',
              ticketCompany: 'AXS',
              ticketType: 'Seated',
              ticketName: 'PL3 Reserved Seating',
              allocation: 120,
              price: 35,
              lastUpdated: '2025-05-18T19:00:00Z',
              feedSales: 50,
              manualSales: 50,
              totalSales: 100,
              percentSold: 83,
              unsold: 20,
            },
            {
              id: 'alloc-o2-1-2',
              ticketCompany: 'The Lowry',
              ticketType: 'Seated',
              ticketName: 'PL1 Reserved Seating',
              allocation: 120,
              price: 35,
              lastUpdated: '2025-05-18T19:00:00Z',
              feedSales: 125,
              manualSales: 40,
              totalSales: 165,
              percentSold: 138,
              unsold: -45,
            },
            {
              id: 'alloc-o2-1-3',
              ticketCompany: 'Ticketmaster',
              ticketType: 'Seated',
              ticketName: 'PL2 Reserved Seating',
              allocation: 120,
              price: 35,
              lastUpdated: '2025-05-18T19:00:00Z',
              feedSales: 125,
              manualSales: 80,
              totalSales: 205,
              percentSold: 171,
              unsold: -85,
            },
            {
              id: 'alloc-o2-1-4',
              ticketCompany: 'Ticketmaster EC',
              ticketType: 'Seated',
              ticketName: 'PL1 Reserved Seating',
              allocation: 120,
              price: 35,
              lastUpdated: '2025-05-18T19:00:00Z',
              feedSales: 125,
              manualSales: 60,
              totalSales: 185,
              percentSold: 154,
              unsold: -65,
            },
            {
              id: 'alloc-o2-1-5',
              ticketCompany: 'AXS',
              ticketType: 'Seated',
              ticketName: 'PL2 Reserved Seating',
              allocation: 120,
              price: 35,
              lastUpdated: '2025-05-18T19:00:00Z',
              feedSales: 125,
              manualSales: -20,
              totalSales: 145,
              percentSold: 121,
              unsold: -25,
            },
            {
              id: 'alloc-o2-1-6',
              ticketCompany: 'The Lowry',
              ticketType: 'Seated',
              ticketName: 'PL3 Reserved Seating',
              allocation: 120,
              price: 35,
              lastUpdated: '2025-05-18T19:00:00Z',
              feedSales: 125,
              manualSales: 68,
              totalSales: 193,
              percentSold: 161,
              unsold: -73,
            },
            {
              id: 'alloc-o2-1-7',
              ticketCompany: 'Ticketmaster',
              ticketType: 'Seated',
              ticketName: 'PL1 Reserved Seating',
              allocation: 120,
              price: 35,
              lastUpdated: '2025-05-18T19:00:00Z',
              feedSales: 125,
              manualSales: 60,
              totalSales: 185,
              percentSold: 154,
              unsold: -65,
            },
            {
              id: 'alloc-o2-1-8',
              ticketCompany: 'Ticketmaster EC',
              ticketType: 'Seated',
              ticketName: 'PL3 Reserved Seating',
              allocation: 120,
              price: 35,
              lastUpdated: '2025-05-18T19:00:00Z',
              feedSales: 95,
              manualSales: 60,
              totalSales: 155,
              percentSold: 129,
              unsold: -35,
            },
            {
              id: 'alloc-o2-1-9',
              ticketCompany: 'AXS',
              ticketType: 'Seated',
              ticketName: 'PL1 Reserved Seating',
              allocation: 120,
              price: 35,
              lastUpdated: '2025-05-18T19:00:00Z',
              feedSales: 95,
              manualSales: 82,
              totalSales: 177,
              percentSold: 148,
              unsold: -57,
            },
            {
              id: 'alloc-o2-1-10',
              ticketCompany: 'The Lowry',
              ticketType: 'Seated',
              ticketName: 'PL2 Reserved Seating',
              allocation: 85,
              price: 35,
              lastUpdated: '2025-05-17T14:30:00Z',
              feedSales: null,
              manualSales: 40,
              totalSales: 40,
              percentSold: 47,
              unsold: 45,
            },
            {
              id: 'alloc-o2-1-11',
              ticketCompany: 'Ticketmaster',
              ticketType: 'Seating',
              ticketName: 'PL3 Reserved Seating',
              allocation: 100,
              price: 45,
              lastUpdated: '2025-05-18T12:00:00Z',
              feedSales: 70,
              manualSales: -10,
              totalSales: 60,
              percentSold: 60,
              unsold: 40,
            },
          ],
        },
        {
          id: 'show-o2-2',
          showNumber: 2,
          eventDate: '2025-05-10',
          allocations: [
            {
              id: 'alloc-o2-2-1',
              ticketCompany: 'AXS',
              ticketType: 'Seated',
              ticketName: 'GA Standing',
              allocation: 0,
              price: 40,
              lastUpdated: '2025-05-16T10:00:00Z',
              feedSales: 0,
              manualSales: 0,
              totalSales: 0,
              percentSold: 0,
              unsold: 0,
            },
            {
              id: 'alloc-o2-2-2',
              ticketCompany: 'Ticketmaster',
              ticketType: 'Seated',
              ticketName: 'PL1 Reserved',
              allocation: 300,
              price: 55,
              lastUpdated: '2025-05-18T12:00:00Z',
              feedSales: 310,
              manualSales: 10,
              totalSales: 320,
              percentSold: 107,
              unsold: -20,
            },
          ],
        },
      ],
    },
    {
      id: 'venue-palladium',
      name: 'London - Palladium',
      showCount: 1,
      firstEventDate: '2025-05-12',
      shows: [
        {
          id: 'show-palladium-1',
          showNumber: 1,
          eventDate: '2025-05-12',
          allocations: [
            {
              id: 'alloc-palladium-1-1',
              ticketCompany: 'Ticketmaster',
              ticketType: 'Seated',
              ticketName: 'Stalls',
              allocation: 1800,
              price: 65,
              lastUpdated: '2025-05-19T09:15:00Z',
              feedSales: 1200,
              manualSales: 50,
              totalSales: 1250,
              percentSold: 69,
              unsold: 550,
            },
            {
              id: 'alloc-palladium-1-2',
              ticketCompany: 'AXS',
              ticketType: 'Seated',
              ticketName: 'Circle',
              allocation: 800,
              price: 50,
              lastUpdated: '2025-05-19T09:15:00Z',
              feedSales: 400,
              manualSales: 0,
              totalSales: 400,
              percentSold: 50,
              unsold: 400,
            },
          ],
        },
      ],
    },
    {
      id: 'venue-symphony',
      name: 'Symphony Hall',
      showCount: 1,
      firstEventDate: '2025-06-01',
      shows: [
        {
          id: 'show-symphony-1',
          showNumber: 1,
          eventDate: '2025-06-01',
          allocations: [
            {
              id: 'alloc-symphony-1-1',
              ticketCompany: 'The Lowry',
              ticketType: 'Seated',
              ticketName: 'PL1',
              allocation: 1200,
              price: 48,
              lastUpdated: '2025-05-20T16:45:00Z',
              feedSales: 900,
              manualSales: 100,
              totalSales: 1000,
              percentSold: 83,
              unsold: 200,
            },
          ],
        },
      ],
    },
  ],
};

export function getTicketSalesTourById(id: string): TicketSalesTour | undefined {
  if (id === ticketSalesMockData.id) {
    return ticketSalesMockData;
  }

  return undefined;
}
